import { Pipe, PipeTransform } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';
import { ValueListsService } from '../services';

@Pipe({ name: 'tagName' })
export class TagNamePipe implements PipeTransform {
  constructor(private valueListsService: ValueListsService) {}

  async transform(key: AnyType, options?: { slice?: number }): Promise<string | undefined> {
    if (Array.isArray(key)) {
      let keys = key;
      if (options?.slice) {
        keys = key.slice(options.slice);
      }
      return (await this.valueListsService.listTags(keys, true)).map((tag) => tag.name).join(', ');
    }

    return this.valueListsService.lookupTagName(key);
  }
}
